// src/components/admin/RoleForm.jsx
import React, { useState } from 'react';
import { Button, Field, ModalActions, TextArea, TextInput } from '../common/ui';

const RoleForm = ({ role, onSubmit, onCancel, isSaving }) => {
  const isNew = !role?._id;
  const [form, setForm] = useState({
    name: role?.name || '',
    description: role?.description || '',
  });
  const [error, setError] = useState('');

  const set = (patch) => setForm((prev) => ({ ...prev, ...patch }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // `isDefault` is deliberately not editable — it's what stops the built-in
      // roles being deleted out from under the app.
      await onSubmit({ name: form.name.trim().toLowerCase(), description: form.description.trim() });
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Could not save this role');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      {error && (
        <p className="rounded-lg bg-danger-soft px-3 py-2.5 text-[13px] text-danger">{error}</p>
      )}

      <Field
        label="Role name"
        htmlFor="role-name"
        hint="One lowercase word. People see this on their profile."
      >
        <TextInput
          id="role-name"
          value={form.name}
          onChange={(e) => set({ name: e.target.value })}
          placeholder="content-team"
          disabled={role?.isDefault}
          required
        />
      </Field>

      <Field
        label="Description"
        htmlFor="role-description"
        hint="Who this is for, in a sentence — it's the only note your future self gets."
      >
        <TextArea
          id="role-description"
          rows={3}
          value={form.description}
          onChange={(e) => set({ description: e.target.value })}
          placeholder="Writers and editors: copy, blog, translation and SEO tools."
          required
        />
      </Field>

      <ModalActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="submit" variant="primary" disabled={isSaving}>
          {isSaving ? 'Saving…' : isNew ? 'Create role' : 'Save changes'}
        </Button>
      </ModalActions>
    </form>
  );
};

export default RoleForm;
